import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import emailjs from '@emailjs/browser';
// USER TODO: Replace these with actual EmailJS credentials
const EMAILJS_SERVICE_ID = 'service_xxxxx';
const EMAILJS_TEMPLATE_ID = 'template_xxxxx';
const EMAILJS_PUBLIC_KEY = 'xxxxx';
export function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    try {
      // Uncomment and use actual credentials when ready
      /*
      await emailjs.sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        e.currentTarget,
        EMAILJS_PUBLIC_KEY
      )
      */
      // Simulate API call for now
      await new Promise(resolve => setTimeout(resolve, 1500));
      setStatus('success');
      (e.target as HTMLFormElement).reset();
    } catch (error) {
      console.error('Error sending email:', error);
      setStatus('error');
    }
  };
  return <section id="contact-form" className="py-20 md:py-24 px-5 sm:px-6 md:px-8 bg-carbon border-t border-white/5 scroll-mt-10" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-12" data-id="element-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gold mb-4" data-id="element-13">
            Solicita Tu Diagnóstico Gratuito
          </h2>
          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-14">
            Completa el formulario y un especialista te contactará en menos de
            24 horas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0a0a0a] border border-white/10 p-6 md:p-10 rounded-2xl shadow-2xl" data-id="element-15">
          {status === 'success' ? <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-16">
              <div className="w-20 h-20 bg-emerald/20 rounded-full flex items-center justify-center mb-6" data-id="element-17">
                <CheckCircle className="w-10 h-10 text-emerald" data-id="element-18" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-19">
                ¡Solicitud Enviada!
              </h3>
              <p className="text-gray-400" data-id="element-20">
                Hemos recibido tu información. Un especialista se pondrá en
                contacto contigo pronto.
              </p>
              <button onClick={() => setStatus('idle')} className="mt-8 text-gold hover:underline font-medium" data-id="element-21">
                Enviar otra solicitud
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-22">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-23">
                {/* Nombre */}
                <div className="space-y-2" data-id="element-24">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-300" data-id="element-25">
                    Nombre Completo *
                  </label>
                  <input type="text" id="name" name="name" required className="w-full bg-white/5 border border-white/10 text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors" placeholder="Dr. Juan Pérez" data-id="element-26" />
                </div>

                {/* Email */}
                <div className="space-y-2" data-id="element-27">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300" data-id="element-28">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required className="w-full bg-white/5 border border-white/10 text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors" placeholder="doctor@clinica.com" data-id="element-29" />
                </div>

                {/* Teléfono */}
                <div className="space-y-2" data-id="element-30">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-300" data-id="element-31">
                    Teléfono *
                  </label>
                  <input type="tel" id="phone" name="phone" required className="w-full bg-white/5 border border-white/10 text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors" placeholder="+1 (555) 000-0000" data-id="element-32" />
                </div>

                {/* Empresa */}
                <div className="space-y-2" data-id="element-33">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-300" data-id="element-34">
                    Nombre de la Clínica / Empresa *
                  </label>
                  <input type="text" id="company" name="company" required className="w-full bg-white/5 border border-white/10 text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors" placeholder="Clínica Dental Avanzada" data-id="element-35" />
                </div>

                {/* Instagram */}
                <div className="space-y-2" data-id="element-36">
                  <label htmlFor="instagram" className="block text-sm font-medium text-gray-300" data-id="element-37">
                    Instagram de la Clínica
                  </label>
                  <input type="text" id="instagram" name="instagram" className="w-full bg-white/5 border border-white/10 text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors" placeholder="@tuclinica" data-id="element-38" />
                </div>

                {/* Website */}
                <div className="space-y-2" data-id="element-39">
                  <label htmlFor="website" className="block text-sm font-medium text-gray-300" data-id="element-40">
                    Sitio Web
                  </label>
                  <input type="url" id="website" name="website" className="w-full bg-white/5 border border-white/10 text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors" placeholder="https://www.tuclinica.com" data-id="element-41" />
                </div>
              </div>

              {/* Selects - Full width */}
              <div className="space-y-6" data-id="element-42">
                <div className="space-y-2" data-id="element-43">
                  <label htmlFor="current_patients" className="block text-sm font-medium text-gray-300" data-id="element-44">
                    ¿Cuántos pacientes nuevos recibes por semana? *
                  </label>
                  <div className="relative" data-id="element-45">
                    <select id="current_patients" name="current_patients" required className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors appearance-none" data-id="element-46">
                      <option value="" disabled selected className="text-gray-900" data-id="element-47">
                        Selecciona una opción
                      </option>
                      <option value="1-5" className="text-gray-900" data-id="element-48">
                        1-5 pacientes
                      </option>
                      <option value="6-15" className="text-gray-900" data-id="element-49">
                        6-15 pacientes
                      </option>
                      <option value="16-30" className="text-gray-900" data-id="element-50">
                        16-30 pacientes
                      </option>
                      <option value="30+" className="text-gray-900" data-id="element-51">
                        Más de 30 pacientes
                      </option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400" data-id="element-52">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-53">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-54" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-55">
                  <label htmlFor="goal_patients" className="block text-sm font-medium text-gray-300" data-id="element-56">
                    ¿Cuál es tu meta semanal de pacientes nuevos? *
                  </label>
                  <div className="relative" data-id="element-57">
                    <select id="goal_patients" name="goal_patients" required className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors appearance-none" data-id="element-58">
                      <option value="" disabled selected className="text-gray-900" data-id="element-59">
                        Selecciona una opción
                      </option>
                      <option value="5-10" className="text-gray-900" data-id="element-60">
                        5-10 pacientes
                      </option>
                      <option value="11-20" className="text-gray-900" data-id="element-61">
                        11-20 pacientes
                      </option>
                      <option value="21-40" className="text-gray-900" data-id="element-62">
                        21-40 pacientes
                      </option>
                      <option value="40+" className="text-gray-900" data-id="element-63">
                        Más de 40 pacientes
                      </option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400" data-id="element-64">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-65">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-66" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-67">
                  <label htmlFor="ads_experience" className="block text-sm font-medium text-gray-300" data-id="element-68">
                    ¿Has invertido en publicidad digital antes? *
                  </label>
                  <div className="relative" data-id="element-69">
                    <select id="ads_experience" name="ads_experience" required className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors appearance-none" data-id="element-70">
                      <option value="" disabled selected className="text-gray-900" data-id="element-71">
                        Selecciona una opción
                      </option>
                      <option value="No nunca" className="text-gray-900" data-id="element-72">
                        No, nunca
                      </option>
                      <option value="Sí pero sin resultados" className="text-gray-900" data-id="element-73">
                        Sí, pero sin resultados
                      </option>
                      <option value="Sí con algunos resultados" className="text-gray-900" data-id="element-74">
                        Sí, con algunos resultados
                      </option>
                      <option value="Sí con buenos resultados" className="text-gray-900" data-id="element-75">
                        Sí, con buenos resultados
                      </option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400" data-id="element-76">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-77">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-78" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-79">
                  <label htmlFor="ad_spend" className="block text-sm font-medium text-gray-300" data-id="element-80">
                    ¿Cuánto has invertido mensualmente en publicidad? *
                  </label>
                  <div className="relative" data-id="element-81">
                    <select id="ad_spend" name="ad_spend" required className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors appearance-none" data-id="element-82">
                      <option value="" disabled selected className="text-gray-900" data-id="element-83">
                        Selecciona una opción
                      </option>
                      <option value="Nada" className="text-gray-900" data-id="element-84">
                        Nada
                      </option>
                      <option value="Menos de $500" className="text-gray-900" data-id="element-85">
                        Menos de $500
                      </option>
                      <option value="$500-$2,000" className="text-gray-900" data-id="element-86">
                        $500 - $2,000
                      </option>
                      <option value="$2,000-$5,000" className="text-gray-900" data-id="element-87">
                        $2,000 - $5,000
                      </option>
                      <option value="Más de $5,000" className="text-gray-900" data-id="element-88">
                        Más de $5,000
                      </option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400" data-id="element-89">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-90">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-91" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-92">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-300" data-id="element-93">
                    Mensaje adicional (Opcional)
                  </label>
                  <textarea id="message" name="message" rows={4} className="w-full bg-white/5 border border-white/10 text-white placeholder-gray-500 rounded-lg px-4 py-3 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors resize-none" placeholder="Cuéntanos un poco más sobre tu clínica y tus objetivos..." data-id="element-94"></textarea>
                </div>
              </div>

              {status === 'error' && <div className="flex items-center p-4 bg-red-500/10 border border-red-500/20 rounded-lg text-red-400" data-id="element-95">
                  <AlertCircle className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-96" />
                  <p className="text-sm" data-id="element-97">
                    Hubo un error al enviar el formulario. Por favor, intenta de
                    nuevo o contáctanos directamente.
                  </p>
                </div>}

              <div className="pt-4 flex flex-col items-center gap-4" data-id="element-98">
                <button type="submit" disabled={status === 'sending'} className="w-full bg-gold text-carbon font-bold text-lg px-8 py-4 rounded-md transition-all duration-300 hover:bg-yellow-400 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-70 disabled:hover:scale-100 flex items-center justify-center" data-id="element-99">
                  {status === 'sending' ? <>
                      <Loader2 className="w-6 h-6 mr-2 animate-spin" data-id="element-100" />
                      ENVIANDO...
                    </> : 'ENVIAR SOLICITUD'}
                </button>

                <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-yellow-400 hover:underline transition-colors text-sm md:text-base font-medium flex items-center justify-center" data-id="element-101">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-102">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-103" />
                  </svg>
                  ¿Prefieres agendar directamente? Haz clic aquí
                </a>
              </div>
            </form>}
        </motion.div>
      </div>
    </section>;
}